import React, { FC, Fragment, useState } from 'react';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import StlViewer from 'components/shared/stl-viewer/stl-viewer.component';

type StlMultiPreviewListProps = {
    stlFiles: { url: string; filename: string }[];
};

const StlMultiPreviewList: FC<StlMultiPreviewListProps> = ({ stlFiles }: StlMultiPreviewListProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [stlFileUrl, setStlFileUrl] = useState('');
    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handlePreview = (url: string) => {
        setPreviewOpen(true);
        setStlFileUrl(url);
    };

    return (
        <Fragment>
            <IconButton aria-controls="stl-multi-preview" aria-haspopup="true" onClick={handleMenu} color="primary">
                <VisibilityIcon />
            </IconButton>

            <Menu
                id="stl-multi-preview"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                {stlFiles.map((stlFile) => (
                    <MenuItem
                        key={stlFile.filename}
                        onClick={() => {
                            handleClose();
                            handlePreview(stlFile.url as string);
                        }}
                    >
                        <ListItemIcon>
                            <VisibilityIcon />
                        </ListItemIcon>
                        <ListItemText primary={stlFile.filename} />
                    </MenuItem>
                ))}
            </Menu>
            <StlViewer url={stlFileUrl} open={previewOpen} onClose={() => setPreviewOpen(false)} />
        </Fragment>
    );
};

export default StlMultiPreviewList;
